import React from 'react';
import { MDBContainer, MDBIcon, MDBBtn } from 'mdbreact';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { TreeSelect, DatePicker, message } from 'antd';
import moment from 'moment';
import axios from 'axios';
import allStrings from '../../assets/strings';
import { BASE_END_POINT } from '../../urls';
import TaskInfo from './taskInfo';
import AddTask from './addTask';
import './task.css';

const { TreeNode } = TreeSelect;

const STATUS_COLUMNS = [
  { id: 'PENDING', title: 'بالانتظار', color: '#3b82f6' },
  { id: 'IN-PROGRESS', title: 'جاري التنفيذ', color: '#f59e0b' },
  { id: 'OVERDUE', title: 'متأخرة', color: '#ef4444' },
  { id: 'FINISHED', title: 'منتهية', color: '#10b981' },
];

const TAG_COLORS = [
  { bg: '#E3F2FD', text: '#1E88E5' },
  { bg: '#E8F5E9', text: '#43A047' },
  { bg: '#F3E5F5', text: '#8E24AA' },
  { bg: '#FFEBEE', text: '#E53935' },
  { bg: '#FFF3E0', text: '#F57C00' },
  { bg: '#E0F2F1', text: '#00897B' },
  { bg: '#FCE4EC', text: '#E91E63' },
  { bg: '#EDE7F6', text: '#673AB7' },
];
const getTagColor = (tag) => {
  let hash = 0;
  for (let i = 0; i < tag.length; i++) hash = tag.charCodeAt(i) + ((hash << 5) - hash);
  return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length];
};

const getTaskCardBgClass = (task, columnId) => {
  const status = task.status || columnId;
  if (status === 'FINISHED') {
    return 'task-card-finished';
  }

  const deadline = task.deadline
  const now = moment();

  if (status === 'OVERDUE') {
    return 'task-card-overdue';
  }

  if (deadline) {
    const due = moment(deadline);
    if (due.isValid()) {
      if (due.isBefore(now)) {
        return 'task-card-overdue';
      }
      const diffInHours = due.diff(now, 'hours', true);
      if (diffInHours <= 48 && diffInHours >= 0) {
        return 'task-card-warning';
      }
    }
  }
  return '';
};

class Task extends React.Component {
  state = {
    // Board - each col: { id, title, color, tasks[], page, hasMore, loadingMore }
    boardData: STATUS_COLUMNS.map(col => ({ ...col, tasks: [], page: 1, hasMore: false, loadingMore: false })),
    loading: false,
    // Filters
    selectedProject: 'all',
    selectedEmployee: 'all',
    // Drawer
    selectedTask: null,
    drawerOpen: false,
    activeTab: 'details',
    // Card menu
    openMenuId: null,
    // Create Task Modal
    createModalOpen: false,
    createTitle: '',
    createDescription: '',
    createProject: null,
    createAssignee: null,
    createTags: [],
    createTagName: '',
    createFiles: [],
    createDueDate: '',
    // Edit Task Modal
    editModalOpen: false,
    editTask: null,
    editTitle: '',
    editDescription: '',
    editProject: null,
    editAssignee: null,
    editTags: [],
    editTagName: '',
    editFiles: [],
    editDueDate: '',
    // Lookup data
    projects: [],
    employees: [],
  };

  constructor(props) {
    super(props);
    if (this.props.isRTL) allStrings.setLanguage('ar');
    else allStrings.setLanguage('en');
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    if (this.props.isRTL) allStrings.setLanguage('ar');
    else allStrings.setLanguage('en');
    this.getProjects();
    this.getUserWithoutPagenation();
    this.getTasks();
    // Close card menu on outside click
    document.addEventListener('click', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
    this.stopAutoScroll();
  }

  handleOutsideClick = () => {
    if (this.state.openMenuId !== null) this.setState({ openMenuId: null });
  };

  authHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${this.props.currentUser.token}`,
    'Accept-Language': this.props.isRTL ? 'ar' : 'en',
  });

  // ─── API: Lookup ─────────────────────────────────────────────────────────

  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`)
      .then(res => this.setState({ projects: res.data.data }))
      .catch(err => console.log('projects error', err.response));
  };

  getUserWithoutPagenation = () => {
    axios.get(`${BASE_END_POINT}quickSearch/get?type=SUB-ADMIN`, { headers: this.authHeaders() })
      .then(res => this.setState({ employees: res.data.data }))
      .catch(err => console.log('employees error', err.response));
  };

  // ─── API: Board ───────────────────────────────────────────────────────────

  buildUrl = (colId, page = 1) => {
    const { selectedProject, selectedEmployee } = this.state;
    const params = [`page=${page}`, `status=${colId}`];
    if (selectedProject && selectedProject !== 'all') params.push(`project=${selectedProject}`);
    if (selectedEmployee && selectedEmployee !== 'all') params.push(`assignedTo=${selectedEmployee}`);
    return `${BASE_END_POINT}tasks?${params.join('&')}`;
  };

  _loadingColumns = new Set();

  getTasks = (projectId = null, assignedTo = null) => {
    this._loadingColumns.clear();
    this.setState({ loading: true });

    const proj = projectId !== null ? projectId : this.state.selectedProject;
    const emp = assignedTo !== null ? assignedTo : this.state.selectedEmployee;

    const columnRequests = STATUS_COLUMNS.map(col => {
      const params = ['page=1', `status=${col.id}`];
      if (proj && proj !== 'all') params.push(`project=${proj}`);
      if (emp && emp !== 'all') params.push(`assignedTo=${emp}`);
      const url = `${BASE_END_POINT}tasks?${params.join('&')}`;

      return axios.get(url, { headers: this.authHeaders() })
        .then(res => {
          let fetchedTasks = [];
          if (res.data) {
            if (Array.isArray(res.data.data)) {
              fetchedTasks = res.data.data;
            } else if (Array.isArray(res.data)) {
              fetchedTasks = res.data;
            } else if (res.data.data && Array.isArray(res.data.data.data)) {
              fetchedTasks = res.data.data.data;
            }
          }
          const pageCount = res.data ? (res.data.pageCount || res.data.data?.pageCount || 1) : 1;
          return {
            ...col,
            tasks: fetchedTasks,
            page: 1,
            hasMore: 1 < pageCount,
            loadingMore: false,
          };
        })
        .catch(err => {
          console.log(`getTasks error for status ${col.id}`, err.response);
          return {
            ...col,
            tasks: [],
            page: 1,
            hasMore: false,
            loadingMore: false,
          };
        });
    });

    Promise.all(columnRequests)
      .then(newBoardData => {
        this.setState(prev => {
          const next = { boardData: newBoardData, loading: false };
          // Update selectedTask if drawer is open so files/etc refresh
          if (prev.drawerOpen && prev.selectedTask) {
            const selId = prev.selectedTask.id || prev.selectedTask._id;
            for (const col of newBoardData) {
              const found = col.tasks.find(t => String(t.id || t._id) === String(selId));
              if (found) {
                const foundId = found.id || found._id;
                next.selectedTask = { ...found, id: foundId, _id: foundId };
                break;
              }
            }
          }
          return next;
        });
      })
      .catch(err => {
        console.log('getTasks Promise.all ERROR', err);
        this.setState({ loading: false });
      });
  };

  _lastScrollTop = {};

  // ─── Infinite Scroll: Load More for a single column ──────────────────────

  loadMoreForColumn = (colId) => {
    const { boardData } = this.state;
    const col = boardData.find(c => c.id === colId);
    if (!col || !col.hasMore || col.loadingMore || this._loadingColumns.has(colId)) return;

    // Synchronously lock this column to prevent duplicate requests on rapid scroll events
    this._loadingColumns.add(colId);

    const nextPage = col.page + 1;

    // Mark loading in React state
    this.setState(prev => ({
      boardData: prev.boardData.map(c => c.id === colId ? { ...c, loadingMore: true } : c),
    }));

    const url = this.buildUrl(colId, nextPage);

    axios.get(url, { headers: this.authHeaders() })
      .then(res => {
        let fetchedTasks = [];
        if (res.data) {
          if (Array.isArray(res.data.data)) {
            fetchedTasks = res.data.data;
          } else if (Array.isArray(res.data)) {
            fetchedTasks = res.data;
          } else if (res.data.data && Array.isArray(res.data.data.data)) {
            fetchedTasks = res.data.data.data;
          }
        }

        const pageCount = res.data ? (res.data.pageCount || res.data.data?.pageCount || 1) : 1;

        if (fetchedTasks.length === 0) {
          this.setState(prev => ({
            boardData: prev.boardData.map(c => c.id === colId ? { ...c, loadingMore: false, hasMore: false } : c),
          }), () => {
            this._loadingColumns.delete(colId);
          });
          return;
        }

        this.setState(prev => ({
          boardData: prev.boardData.map(c => {
            if (c.id !== colId) return c;

            // Avoid duplicate tasks by checking non-empty String(id)
            const existingIds = new Set(
              c.tasks.map(t => String(t.id || t._id || '')).filter(Boolean)
            );

            const newTasks = fetchedTasks.filter(t => {
              if (!t) return false;
              const taskId = String(t.id || t._id || '');
              if (!taskId) return true;
              return !existingIds.has(taskId);
            });

            const hasMore = nextPage < pageCount && fetchedTasks.length > 0;

            return {
              ...c,
              tasks: [...c.tasks, ...newTasks],
              page: nextPage,
              hasMore: hasMore,
              loadingMore: false,
            };
          }),
        }), () => {
          // Release lock after state is updated
          this._loadingColumns.delete(colId);
        });
      })
      .catch(err => {
        console.log('loadMore error', err.response || err);
        this.setState(prev => ({
          boardData: prev.boardData.map(c => c.id === colId ? { ...c, loadingMore: false } : c),
        }), () => {
          this._loadingColumns.delete(colId);
        });
      });
  };

  handleColumnScroll = (e, colId) => {
    const el = e.currentTarget;
    const lastTop = this._lastScrollTop[colId] || 0;
    const currentTop = el.scrollTop;
    this._lastScrollTop[colId] = currentTop;

    // Trigger ONLY if user is actively scrolling DOWNWARDS
    if (currentTop <= lastTop) return;

    // Calculate distance from bottom: scrollHeight - (scrollTop + clientHeight)
    const distanceFromBottom = el.scrollHeight - currentTop - el.clientHeight;
    // Trigger ONLY when user scrolls down to within 30px of the very bottom
    if (distanceFromBottom <= 30) {
      this.loadMoreForColumn(colId);
    }
  };

  // ─── Filters ──────────────────────────────────────────────────────────────

  handleFilterChange = (name, value) => {
    this.setState({ [name]: value }, () => {
      const { selectedProject, selectedEmployee } = this.state;
      this.getTasks(selectedProject, selectedEmployee);
    });
  };

  // ─── Create Task ──────────────────────────────────────────────────────────

  handleCreateTask = () => {
    const { createTitle, createDescription, createProject, createAssignee, createTags, createFiles, createDueDate } = this.state;
    if (!createTitle.trim()) { message.warning('يرجى إدخال عنوان المهمة'); return; }
    if (!createDescription.trim()) { message.warning('يرجى إدخال تفاصيل / وصف المهمة'); return; }
    if (!createProject) { message.warning('يرجى اختيار المشروع'); return; }

    const l = message.loading('جاري الإضافة...', 0);
    const data = new FormData();
    data.append('title', createTitle);
    data.append('description', createDescription || '');
    data.append('project', createProject);
    if (createAssignee) data.append('assignedTo', createAssignee);
    if (createDueDate) data.append('deadline', createDueDate);
    createTags.forEach(tag => data.append('tags[]', tag.text));
    createFiles.forEach(file => data.append('files', file));

    axios.post(`${BASE_END_POINT}tasks`, data, {
      headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${this.props.currentUser.token}`, 'Accept-Language': this.props.isRTL ? 'ar' : 'en' },
    })
      .then(() => {
        l();
        message.success('تمت إضافة المهمة بنجاح', 2.5);
        this.setState({ createModalOpen: false, createTitle: '', createDescription: '', createProject: null, createAssignee: null, createTags: [], createTagName: '', createFiles: [], createDueDate: '' });
        this.getTasks();
      })
      .catch(err => {
        l();
        message.error(err.response?.data?.errors?.[0]?.msg || 'حدث خطأ', 2.5);
      });
  };

  openCreateModal = () => {
    this.setState({ createModalOpen: true, createTitle: '', createDescription: '', createProject: null, createAssignee: null, createTags: [], createTagName: '', createFiles: [], createDueDate: '' });
  };

  handleCreateAddTag = () => {
    const { createTagName, createTags } = this.state;
    if (!createTagName.trim()) return;
    const c = TAG_COLORS[Math.floor(Math.random() * TAG_COLORS.length)];
    this.setState({ createTags: [...createTags, { text: createTagName, color: c.bg, textColor: c.text }], createTagName: '' });
  };

  handleCreateDeleteTag = (tagText) => {
    this.setState({ createTags: this.state.createTags.filter(t => t.text !== tagText) });
  };

  // ─── Edit Task ────────────────────────────────────────────────────────────

  openEditModal = (task) => {
    this.setState({
      editModalOpen: true,
      editTask: task,
      editTitle: task.title || '',
      editDescription: task.description || '',
      editProject: task.project?.id || task.project || null,
      editAssignee: task.assignedTo?.id || null,
      editTags: (task.tags || []).map(t => {
        const tagStr = typeof t === 'string' ? t : (t.text || '');
        const c = getTagColor(tagStr);
        return { text: tagStr, color: c.bg, textColor: c.text };
      }),
      editTagName: '',
      editFiles: [],
      editDueDate: task.deadline ? moment(task.deadline).format('YYYY-MM-DD') : '',
    });
  };

  handleUpdateTask = () => {
    const { editTask, editTitle, editDescription, editProject, editAssignee, editTags, editFiles, editDueDate } = this.state;
    const taskId = editTask?.id || editTask?._id;
    if (!editTitle.trim()) { message.warning('يرجى إدخال عنوان المهمة'); return; }
    if (!editDescription.trim()) { message.warning('يرجى إدخال تفاصيل / وصف المهمة'); return; }
    if (!editProject) { message.warning('يرجى اختيار المشروع'); return; }
    if (!taskId) { message.error('معرف المهمة غير صالح'); return; }

    const l = message.loading('جاري التعديل...', 0);
    const data = new FormData();
    data.append('title', editTitle);
    data.append('description', editDescription || '');
    data.append('project', editProject);
    if (editAssignee) data.append('assignedTo', editAssignee);
    if (editDueDate) data.append('deadline', editDueDate);
    editTags.forEach(tag => data.append('tags[]', tag.text));
    editFiles.forEach(file => data.append('files', file));

    axios.put(`${BASE_END_POINT}tasks/${taskId}`, data, {
      headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${this.props.currentUser.token}`, 'Accept-Language': this.props.isRTL ? 'ar' : 'en' },
    })
      .then(() => {
        l();
        message.success('تم تعديل المهمة بنجاح', 2.5);
        this.setState({ editModalOpen: false, editTask: null });
        this.getTasks(this.state.selectedProject, this.state.selectedEmployee);
      })
      .catch(err => {
        l();
        message.error(err.response?.data?.errors?.[0]?.msg || 'حدث خطأ أثناء التعديل', 2.5);
      });
  };

  handleEditAddTag = () => {
    const { editTagName, editTags } = this.state;
    if (!editTagName.trim()) return;
    const c = TAG_COLORS[Math.floor(Math.random() * TAG_COLORS.length)];
    this.setState({ editTags: [...editTags, { text: editTagName, color: c.bg, textColor: c.text }], editTagName: '' });
  };

  handleEditDeleteTag = (tagText) => {
    this.setState({ editTags: this.state.editTags.filter(t => t.text !== tagText) });
  };

  // ─── Delete Task (from card menu) ─────────────────────────────────────────

  handleDeleteTaskFromCard = (taskId) => {
    if (!taskId) return;
    const l = message.loading('جاري الحذف...', 0);
    axios.delete(`${BASE_END_POINT}tasks/${taskId}`, { headers: this.authHeaders() })
      .then(() => {
        l();
        message.success('تم حذف المهمة', 2.5);
        this.setState(prev => ({
          openMenuId: null,
          boardData: prev.boardData.map(col => ({
            ...col,
            tasks: col.tasks.filter(t => (t.id || t._id) !== taskId),
          })),
        }));
      })
      .catch(err => {
        l();
        message.error(err.response?.data?.errors?.[0]?.msg || 'حدث خطأ', 2);
      });
  };

  // ─── Drawer handlers (passed to TaskInfo) ────────────────────────────────

  handleAssigneeChange = (value) => {
    this.setState(prev => {
      if (!prev.selectedTask) return null;
      const taskId = prev.selectedTask.id || prev.selectedTask._id;
      return {
        selectedTask: {
          ...prev.selectedTask,
          id: taskId,
          _id: taskId,
          assignedTo: { ...(prev.selectedTask.assignedTo || {}), id: value, _id: value },
        },
      };
    });
  };

  handleProjectChange = (value) => {
    this.setState(prev => {
      if (!prev.selectedTask) return null;
      const taskId = prev.selectedTask.id || prev.selectedTask._id;
      return {
        selectedTask: {
          ...prev.selectedTask,
          id: taskId,
          _id: taskId,
          project: { ...(prev.selectedTask.project || {}), id: value, _id: value },
        },
      };
    });
  };

  handleDateChange = (date, dateString) => {
    if (!dateString) return;
    this.setState(prev => {
      if (!prev.selectedTask) return null;
      const taskId = prev.selectedTask.id || prev.selectedTask._id;
      return {
        selectedTask: {
          ...prev.selectedTask,
          id: taskId,
          _id: taskId,
          deadline: dateString,
        },
      };
    });
  };

  // ─── Drag & Drop (Long-press to drag, click to open) ─────────────────────

  kanbanBoardRef = React.createRef();
  _currentMouseX = 0;
  _currentMouseY = 0;
  _autoScrollFrame = null;

  _longPressTimer = null;   // timer ref
  _longPressTask = null;   // task pending long-press
  _longPressCol = null;   // column pending long-press
  _pendingRect = null;   // card rect at mouseDown
  _pendingOffset = null;   // drag offset at mouseDown
  _didDrag = false;  // did we actually activate drag?

  startAutoScroll = () => {
    this.stopAutoScroll();

    const scrollStep = () => {
      if (this.state.isDraggingMouse && this.kanbanBoardRef.current) {
        const container = this.kanbanBoardRef.current;
        const rect = container.getBoundingClientRect();
        const mouseX = this._currentMouseX;
        const threshold = 120; // 120px edge zone for autoscroll trigger

        const distRight = rect.right - mouseX;
        const distLeft = mouseX - rect.left;

        if (distRight < threshold && distRight > -100) {
          // Near right edge -> scroll right
          const intensity = Math.max(0.1, (threshold - distRight) / threshold);
          const speed = Math.round(intensity * 24);
          container.scrollLeft += speed;
        } else if (distLeft < threshold && distLeft > -100) {
          // Near left edge -> scroll left
          const intensity = Math.max(0.1, (threshold - distLeft) / threshold);
          const speed = Math.round(intensity * 24);
          container.scrollLeft -= speed;
        }

        this._autoScrollFrame = requestAnimationFrame(scrollStep);
      }
    };

    this._autoScrollFrame = requestAnimationFrame(scrollStep);
  };

  stopAutoScroll = () => {
    if (this._autoScrollFrame) {
      cancelAnimationFrame(this._autoScrollFrame);
      this._autoScrollFrame = null;
    }
  };

  handleMouseDown = (e, task, colId) => {
    if (e.button !== 0 || e.target.closest('.task-menu-trigger') || e.target.closest('.task-footer') || e.target.closest('.task-check-btn')) return;

    const cardEl = e.currentTarget;
    const rect = cardEl.getBoundingClientRect();

    this._currentMouseX = e.clientX;
    this._currentMouseY = e.clientY;

    // Store pending info — drag hasn't started yet
    this._longPressTask = task;
    this._longPressCol = colId;
    this._pendingRect = rect;
    this._pendingOffset = { x: e.clientX - rect.left, y: e.clientY - rect.top };
    this._didDrag = false;

    // Listen for move/up immediately so we can cancel on early release
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);

    // Activate drag only after 220ms hold
    this._longPressTimer = setTimeout(() => {
      this._didDrag = true;
      this.setState({
        isDraggingMouse: true,
        draggedTaskMouse: this._longPressTask,
        draggedTaskSourceColId: this._longPressCol,
        dragOffset: this._pendingOffset,
        mousePosition: { x: e.clientX, y: e.clientY },
        draggedCardWidth: this._pendingRect.width,
        draggedCardHeight: this._pendingRect.height,
      }, () => {
        this.startAutoScroll();
      });
    }, 220);

    e.preventDefault();
  };

  handleMouseMove = (e) => {
    this._currentMouseX = e.clientX;
    this._currentMouseY = e.clientY;

    // Only update ghost position if drag is active
    if (this.state.isDraggingMouse) {
      this.setState({ mousePosition: { x: e.clientX, y: e.clientY } });
    }
  };

  handleMouseUp = (e) => {
    this.stopAutoScroll();

    // Cancel the long-press timer (user released before 220ms)
    if (this._longPressTimer) {
      clearTimeout(this._longPressTimer);
      this._longPressTimer = null;
    }

    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);

    if (!this._didDrag) {
      // Short click → open drawer
      if (this._longPressTask) {
        const taskId = this._longPressTask.id || this._longPressTask._id;
        const taskWithId = { ...this._longPressTask, id: taskId, _id: taskId };
        this.setState({ selectedTask: taskWithId, drawerOpen: true, activeTab: 'details' });
      }
      this._longPressTask = null;
      this._longPressCol = null;
      return;
    }

    // Drag was active → find drop target
    const { draggedTaskMouse, draggedTaskSourceColId, boardData } = this.state;
    if (!draggedTaskMouse) return;

    const columns = document.querySelectorAll('.kanban-column');
    let targetColId = null;
    columns.forEach(col => {
      const rect = col.getBoundingClientRect();
      if (e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom)
        targetColId = col.getAttribute('data-colid');
    });

    if (targetColId && targetColId !== String(draggedTaskSourceColId)) {
      const taskId = draggedTaskMouse.id || draggedTaskMouse._id;
      const updatedTask = { ...draggedTaskMouse, status: targetColId, id: taskId, _id: taskId };
      this.updateTaskStatus(updatedTask, targetColId);
      this.setState({
        boardData: boardData.map(col => {
          if (col.id === draggedTaskSourceColId) return { ...col, tasks: col.tasks.filter(t => String(t.id || t._id) !== String(taskId)) };
          if (col.id === targetColId) return { ...col, tasks: [updatedTask, ...col.tasks] };
          return col;
        }),
      });
    }

    this.setState({ isDraggingMouse: false, draggedTaskMouse: null, draggedTaskSourceColId: null });
    this._didDrag = false;
    this._longPressTask = null;
    this._longPressCol = null;
  };

  updateTaskStatus = (task, newStatus) => {
    const taskId = task.id || task._id;
    if (!taskId) {
      message.error('معرف المهمة غير موجود');
      return;
    }
    const data = new FormData();
    data.append('status', newStatus);
    data.append('title', task.title || '');
    data.append('description', task.description || '');
    axios.put(`${BASE_END_POINT}tasks/${taskId}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    })
      .then(() => {
        console.log('تم تغيير حالة المهمة بنجاح');
        // message.success('تم تغيير حالة المهمة بنجاح');
      })
      .catch(err => {
        console.log('updateTaskStatus error', err.response);
        message.error(err.response?.data?.errors?.[0]?.msg || 'حدث خطأ أثناء تغيير حالة المهمة');
        this.getTasks(this.state.selectedProject, this.state.selectedEmployee);
      });
  };

  handleToggleTaskFinished = (e, task, currentColId) => {
    e.stopPropagation();
    e.preventDefault();
    const taskId = task.id || task._id;
    const isCurrentlyFinished = task.status === 'FINISHED' || currentColId === 'FINISHED';
    const targetColId = isCurrentlyFinished ? 'PENDING' : 'FINISHED';

    const updatedTask = { ...task, status: targetColId, id: taskId, _id: taskId };
    this.updateTaskStatus(updatedTask, targetColId);

    this.setState(prev => ({
      boardData: prev.boardData.map(col => {
        if (col.id === currentColId) {
          return { ...col, tasks: col.tasks.filter(t => String(t.id || t._id) !== String(taskId)) };
        }
        if (col.id === targetColId) {
          return { ...col, tasks: [updatedTask, ...col.tasks] };
        }
        return col;
      }),
    }));
  };

  // ─── Floating Drag Card ───────────────────────────────────────────────────

  renderFloatingCard = () => {
    const { draggedTaskMouse, mousePosition, dragOffset, draggedCardWidth, draggedCardHeight, draggedTaskSourceColId } = this.state;
    if (!draggedTaskMouse) return null;
    const task = draggedTaskMouse;
    const bgClass = getTaskCardBgClass(task, draggedTaskSourceColId);
    return (
      <div
        className={`task-card floating-drag-card ${bgClass}`}
        style={{ position: 'fixed', left: `${mousePosition.x - dragOffset.x}px`, top: `${mousePosition.y - dragOffset.y}px`, width: `${draggedCardWidth}px`, height: `${draggedCardHeight}px`, pointerEvents: 'none', zIndex: 9999 }}
      >
        <h5 className="task-card-title">{task.title}</h5>
        <p className="task-card-description">{task.description}</p>
      </div>
    );
  };

  // ─── Render ───────────────────────────────────────────────────────────────

  render() {
    const { boardData, selectedProject, selectedEmployee, loading, projects, employees, openMenuId } = this.state;
    const isRTL = this.props.isRTL;

    return (
      <div className={`App ${isRTL ? 'rtl' : ''}`}>
        <MDBContainer>

          {/* Header */}
          <div className="kanban-header">
            <div className="kanban-header-left">
              <MDBBtn
                onClick={this.openCreateModal}
                style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff', borderRadius: '8px', padding: '10px 10px', margin: '0' }}
                className="z-depth-1a"
              >
                <MDBIcon icon="plus" className={isRTL ? 'ml-2' : 'mr-2'} />
                <span>مهمة جديدة</span>
              </MDBBtn>
              <MDBBtn
                color='none'
                onClick={() => this.getTasks(selectedProject, selectedEmployee)}
                style={{ background: 'transparent', color: '#1D9598', border: '1px solid #1D9598', borderRadius: '8px', padding: '6px 12px', margin: '0 8px 0 0' }}
              >
                <MDBIcon icon="sync-alt" />
              </MDBBtn>
            </div>
            <div className="kanban-filters" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
              <TreeSelect
                virtual={false}
                value={selectedProject}
                style={{ width: '160px' }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="جميع المشاريع"
                onChange={(v) => this.handleFilterChange('selectedProject', v)}
              >
                <TreeNode value="all" title="جميع المشاريع" key="all" />
                {projects.map(p => <TreeNode key={p.id || p._id} value={p.id || p._id} title={isRTL ? p.name_ar : p.name_en} />)}
              </TreeSelect>
              <TreeSelect
                virtual={false}
                value={selectedEmployee}
                style={{ width: '160px' }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="كل الموظفين"
                onChange={(v) => this.handleFilterChange('selectedEmployee', v)}
              >
                <TreeNode value="all" title="كل الموظفين" key="all" />
                {employees.map(emp => <TreeNode key={emp.id || emp._id} value={emp.id || emp._id} title={emp.fullname} />)}
              </TreeSelect>
            </div>
          </div>

          {/* Kanban Board */}
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px', color: '#1d9598', fontSize: '18px' }}>
              <MDBIcon icon="spinner" spin /> جاري التحميل...
            </div>
          ) : (
            <div className="kanban-board" ref={this.kanbanBoardRef}>
              {boardData.map((column) => (
                <div key={column.id} className="kanban-column" data-colid={column.id}>
                  {/* Column Header */}
                  <div className="column-header">
                    <div className="column-title-wrapper">
                      <span className="column-dot" style={{ backgroundColor: column.color }}></span>
                      <span className="column-title">{column.title}</span>
                    </div>
                    <span className="column-count">{column.tasks.length}</span>
                  </div>

                  {/* Scrollable Task List with Infinite Scroll */}
                  <div
                    className="task-list"
                    onScroll={(e) => this.handleColumnScroll(e, column.id)}
                  >
                    {column.tasks.map((task) => {
                      const taskId = task.id || task._id;
                      const draggedId = this.state.draggedTaskMouse?.id || this.state.draggedTaskMouse?._id;
                      const isBeingDragged = this.state.isDraggingMouse && draggedId === taskId;
                      if (isBeingDragged) {
                        return <div key={taskId || Math.random()} className="task-card-placeholder" style={{ height: `${this.state.draggedCardHeight}px` }} />;
                      }

                      const bgClass = getTaskCardBgClass(task, column.id);
                      const isFinished = task.status === 'FINISHED' || column.id === 'FINISHED';

                      return (
                        <div
                          key={taskId || Math.random()}
                          className={`task-card ${bgClass}`}
                          onMouseDown={(e) => this.handleMouseDown(e, task, column.id)}
                        >
                          {/* Card Header */}
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, minWidth: 0 }}>
                              <button
                                className={`task-check-btn ${isFinished ? 'checked' : ''}`}
                                title={isFinished ? 'تغيير للانتظار' : 'تعليم كمنتهية'}
                                onClick={(e) => this.handleToggleTaskFinished(e, task, column.id)}
                              >
                                <MDBIcon icon="check" />
                              </button>
                              <h5 className="task-card-title">{task.title}</h5>
                            </div>
                          </div>

                          <p className="task-card-description">{task.description}</p>

                          {/* Tags */}
                          <div className="task-tags">
                            {(task.tags || []).map((tag, idx) => {
                              const tagStr = typeof tag === 'string' ? tag : (tag.text || '');
                              const c = getTagColor(tagStr);
                              return (
                                <span key={idx} className="task-tag" style={{ backgroundColor: c.bg, color: c.text }}>
                                  {tagStr}
                                </span>
                              );
                            })}
                          </div>

                          {/* Footer */}
                          <div className="task-footer">
                            <div className="task-assignee">
                              <img
                                src={task.assignedTo?.img ? task.assignedTo.img : require('../../assets/images/logoC.png')}
                                alt={task.assignedTo?.fullname || 'CRM'}
                                className="assignee-avatar"
                              />
                              <span className="assignee-name">{task.assignedTo?.fullname || '—'}</span>
                            </div>
                            <div className="task-meta">
                              <span className="meta-item">
                                <MDBIcon far icon="clock" className="meta-icon" />
                                <span>{task.deadline ? moment(task.deadline).format('YYYY/MM/DD') : '—'}</span>
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                    {/* Loading more spinner */}
                    {column.loadingMore && (
                      <div style={{ textAlign: 'center', padding: '12px', color: '#1d9598' }}>
                        <MDBIcon icon="spinner" spin style={{ fontSize: '16px' }} />
                      </div>
                    )}

                    {/* End of list indicator */}
                    {!column.hasMore && column.tasks.length > 0 && (
                      <div style={{ textAlign: 'center', padding: '10px', fontSize: '11px', color: '#cbd5e1' }}>
                        لا توجد مهام إضافية
                      </div>
                    )}
                  </div>

                  {/* Add inline button */}
                  {/* <button className="add-task-inline-btn" onClick={this.openCreateModal}>
                    <MDBIcon icon="plus" />
                    <span>مهمة جديدة</span>
                  </button> */}
                </div>
              ))}
            </div>
          )}

        </MDBContainer>

        {/* Details Drawer */}
        {this.state.drawerOpen && this.state.selectedTask && (
          <TaskInfo
            selectedTask={this.state.selectedTask}
            activeTab={this.state.activeTab}
            employees={employees}
            projects={projects}
            isRTL={isRTL}
            currentUser={this.props.currentUser}
            onClose={() => this.setState({ drawerOpen: false })}
            onSetActiveTab={(tab) => this.setState({ activeTab: tab })}
            onDateChange={this.handleDateChange}
            onAssigneeChange={this.handleAssigneeChange}
            onProjectChange={this.handleProjectChange}
            onAddTag={(tagName) => {
              if (!tagName?.trim()) return;
              this.setState(prev => {
                if (!prev.selectedTask) return null;
                const taskId = prev.selectedTask.id || prev.selectedTask._id;
                return {
                  selectedTask: {
                    ...prev.selectedTask,
                    id: taskId,
                    _id: taskId,
                    tags: [...(prev.selectedTask.tags || []), tagName],
                  },
                };
              });
            }}
            onRefreshTask={() => this.getTasks(this.state.selectedProject, this.state.selectedEmployee)}
          />
        )}

        {/* Create Task Modal */}
        {this.state.createModalOpen && (
          <AddTask
            createTitle={this.state.createTitle}
            createDescription={this.state.createDescription}
            createProject={this.state.createProject}
            createAssignee={this.state.createAssignee}
            createTags={this.state.createTags}
            createTagName={this.state.createTagName}
            createFiles={this.state.createFiles}
            createDueDate={this.state.createDueDate}
            projects={projects}
            employees={employees}
            isRTL={isRTL}
            onClose={() => this.setState({ createModalOpen: false })}
            onTitleChange={(v) => this.setState({ createTitle: v })}
            onDescriptionChange={(v) => this.setState({ createDescription: v })}
            onAssigneeChange={(v) => this.setState({ createAssignee: v })}
            onProjectChange={(v) => this.setState({ createProject: v })}
            onDueDateChange={(v) => this.setState({ createDueDate: v })}
            onTagNameChange={(v) => this.setState({ createTagName: v })}
            onAddTag={this.handleCreateAddTag}
            onDeleteTag={this.handleCreateDeleteTag}
            onFilesChange={(files) => this.setState({ createFiles: files })}
            onCreateTask={this.handleCreateTask}
          />
        )}

        {/* Edit Task Modal */}
        {this.state.editModalOpen && (
          <AddTask
            isEdit
            createTitle={this.state.editTitle}
            createDescription={this.state.editDescription}
            createProject={this.state.editProject}
            createAssignee={this.state.editAssignee}
            createTags={this.state.editTags}
            createTagName={this.state.editTagName}
            createFiles={this.state.editFiles}
            createDueDate={this.state.editDueDate}
            projects={projects}
            employees={employees}
            isRTL={isRTL}
            onClose={() => this.setState({ editModalOpen: false })}
            onTitleChange={(v) => this.setState({ editTitle: v })}
            onDescriptionChange={(v) => this.setState({ editDescription: v })}
            onAssigneeChange={(v) => this.setState({ editAssignee: v })}
            onProjectChange={(v) => this.setState({ editProject: v })}
            onDueDateChange={(v) => this.setState({ editDueDate: v })}
            onTagNameChange={(v) => this.setState({ editTagName: v })}
            onAddTag={this.handleEditAddTag}
            onDeleteTag={this.handleEditDeleteTag}
            onFilesChange={(files) => this.setState({ editFiles: files })}
            onCreateTask={this.handleUpdateTask}
          />
        )}

        {/* Floating drag card */}
        {this.state.isDraggingMouse && this.renderFloatingCard()}
      </div>
    );
  }
}

const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

export default connect(mapToStateProps)(withRouter(Task));